<template>
  <div>
    <b-form @submit="onSubmit">
      <b-form-group
        id="input-group-first-name"
        label="First Name :"
        label-for="input-1"
      >
        <b-form-input
          id="input-first-name"
          v-model="form.firstName"
          placeholder="Enter First Name"
          type="text"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-username"
        label="Username :"
        label-for="input-2"
      >
        <b-form-input
          id="input-username"
          v-model="form.userName"
          placeholder="Enter Username"
          type="text"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-email-address"
        label="Email Address :"
        label-for="input-3"
      >
        <b-form-input
          id="input-email-address"
          v-model="form.emailAddress"
          placeholder="Enter Email Address"
          type="text"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-password"
        label="Password :"
        label-for="input-3"
      >
        <b-form-input
          id="input-password"
          v-model="form.passWord"
          placeholder="Enter Password"
          type="password"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-re-password"
        label="Confirm password :"
        label-for="input-3"
      >
        <b-form-input
          id="input-re-password"
          placeholder="Enter Password"
          type="password"
          required
        ></b-form-input>
      </b-form-group>
      <b-button type="submit" variant="primary">Submit</b-button>
      <b-button variant="danger" @click="closeModal($event.target)"
        >Cancel</b-button
      >
    </b-form>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
export default {
  name: "AddTeamForm",
  props: ["modalId"],
  data() {
    return {
      form: {
        firstName: "",
        userName: "",
        emailAddress: "",
        passWord: "",
      },
      show: true,
    };
  },
  computed: {
    ...mapGetters(["getToken", "getTeamList"]),
  },
  methods: {
    ...mapActions([
      "createTeamAccount",
      "showLoadingProcess",
      "closeLoading",
      "fetchTeamList",
    ]),
    async onSubmit(evt) {
      evt.preventDefault();
      const token = this.getToken;
      const {firstName, userName, emailAddress, passWord} = this.form;
      await this.showLoadingProcess();
      try {
        await this.createTeamAccount({
          firstName,
          userName,
          emailAddress,
          passWord,
          token,
        });
        this.$bvModal.hide(this.modalId);
      } catch (err) {
        console.log(err);
      } finally {
        await this.closeLoading();
      }
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>
